import { Component, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { BaseComponent } from 'src/app/system-common/base/base.component';
import { SettingService } from 'src/app/system-common/services/setting.service';
import { AgentService } from '../services/agent.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ResponseIO } from 'src/app/models/responseIO';

@Component({
  selector: '',
  template: '',
})
export class AgentProfileHandlerComponent extends BaseComponent<AgentService> implements OnChanges, OnInit {
  agentProfileDetails = [];
  agentImage: string = '';
  agentName: string;
  designation: string = '';
  agentEmail: string = '';
  agentPhone: string = '';
  agentID: string = '';
  licenseTypes: string = '';
  expiryDate: string = '';
  agentAddress: string = '';
  endorsementConfigList: any[] = [];
  showProfile: boolean;
  endorsementFormData: any = {};
  arrvalidationerrors: string[] = [];
  message: string = '';
  originalFormData: any = {};
  modifiedSectionsSet: Set<string> = new Set();
  modifiedFieldsMap: { [section: string]: Set<string> } = {};

  constructor(
    agentService: AgentService,
    public settingService: SettingService,
    public router: Router,
    public route: ActivatedRoute
  ) {
    super(agentService);
    this.showProfile = true;
  }

  ngOnInit() {
    let userLoginData;
    if (sessionStorage.getItem('userLoginData') != undefined) {
      userLoginData = JSON.parse(sessionStorage.getItem('userLoginData'));
    }
    let agentId = this.route.snapshot.paramMap.get('id') || userLoginData.agentId;
    this.getAgentProfile(agentId != undefined || agentId != null ? agentId : userLoginData.agentId);
    this.getEndorsementConfiguration();
  }

  ngOnChanges(changes: SimpleChanges) {
    super.ngOnChanges(changes);
  }

  getEndorsementConfiguration() {
    this.service.getEndorsementConfiguration().subscribe((res: any) => {
      if (res?.success && res?.data?.agentEndorsementConfigData) {
        this.endorsementConfigList = res.data.agentEndorsementConfigData.map((config: any) => ({
          ...config,
          parsedFields:
            config.FIELDLIST && typeof config.FIELDLIST === 'string'
              ? config.FIELDLIST.split(',')
                  .map((f) => f.trim())
                  .filter((f) => f)
              : [],
        }));
      }
    });
  }

  onEditClick() {
    this.showProfile = false;
  }

  onCancelEdit() {
    this.showProfile = true;
  }

  getAgentProfile(id: string) {
    this.service.getAgentProfile(id).subscribe((agentProfileDetails) => {
      let resData = JSON.parse(JSON.stringify(agentProfileDetails));
      if (!resData?.data) return;

      this.service.responseIO = new ResponseIO();
      this.service.responseIO = JSON.parse(JSON.stringify(resData));
      this.service.responseIO.data.AgentParty = resData.data['AgentParty'];
      const agentParty = resData.data['AgentParty'] ?? {};
      const entity = resData.data['Entity'] ?? {};
      const licenseList = resData.data['LicenseList'] ?? {};
      const agentImg = resData.data['AgentImage'] ?? {};

      this.agentImage = agentImg.agentImage;
      this.agentEmail = agentParty['PersonalEmail']?.emailAddress;
      this.agentPhone = agentParty['MobileContact']?.contactNum;
      this.agentAddress = agentParty['ResidentalAddress']?.addressLine1Lang1;
      this.agentID = entity.agentId != null ? entity.agentId : this.agentID;

      const licenseEntries = Object.values(licenseList);
      this.licenseTypes = licenseEntries
        .map((entry: any) => entry.licenseType)
        .filter(Boolean)
        .join(', ');
      this.expiryDate = licenseEntries
        .map((entry: any) => entry.effectiveToDt)
        .filter(Boolean)
        .join(', ');

      this.endorsementFormData = {};
      this.endorsementConfigList.forEach((config: any) => {
        const sectionName = config.CHANGETYPECD;
        const fields = config.FIELDLIST ? config.FIELDLIST.split(',').filter((f) => f != '') : [];
        const sectionData: any = {};
        fields.forEach((field: string) => {
          const key = field.trim();
          let value = '';
          const changeType = config.CHANGETYPECD ?? '';

          let source: any = agentParty;

          const possibleKey = Object.keys(agentParty).find((k) => {
            const isObject = agentParty[k] && typeof agentParty[k] === 'object';
            return isObject && k === changeType;
          });

          if (possibleKey && typeof agentParty[possibleKey] === 'object') {
            source = agentParty[possibleKey];
          }

          value = key in source ? source[key] ?? '' : '';
          sectionData[key] = value;
        });

        this.endorsementFormData[sectionName] = sectionData;
      });
      this.originalFormData = JSON.parse(JSON.stringify(this.endorsementFormData));
    });
  }

  onInputChanged(event: any, CHANGETYPECD?: string) {
    const field = event?.fieldCd;
    const value = event?.fieldValue;

    if (!field) return;

    let sectionFound: string | null = null;

    if (CHANGETYPECD) {
      sectionFound = CHANGETYPECD;
    }

    if (!sectionFound) {
      return;
    }
    if (sectionFound === 'ResidentalAddress') {
      this.endorsementFormData[sectionFound]['addressTypeCd'] = 'R';
    }

    if (sectionFound === 'OfficeAddress') {
      this.endorsementFormData[sectionFound]['addressTypeCd'] = 'B';
    }
    this.endorsementFormData[sectionFound][field] = value;

    this.modifiedSectionsSet.add(sectionFound);

    if (!this.modifiedFieldsMap[sectionFound]) {
      this.modifiedFieldsMap[sectionFound] = new Set();
    }
    this.modifiedFieldsMap[sectionFound].add(field);
  }

  onSaveChanges() {
    const changedSections = Object.keys(this.endorsementFormData).filter((section) => {
      const current = this.endorsementFormData[section];
      const original = this.originalFormData?.[section] || {};
      return Object.keys(current).some((field) => current[field] !== original[field]);
    });

    if (changedSections.length === 0) {
      this.message = 'No changes detected.';
      this.openModal('saveModal');
      return;
    }

    const formattedSections = changedSections
      .map((section) => section.toLowerCase().replace(/\s+/g, ''))
      .join(',');

    const payload = {
      data: {
        agentId: this.agentID,

        modifiedSections: formattedSections,
        reason: 'Change in ' + formattedSections,

        ...this.transformSectionData(this.endorsementFormData),
      },
    };

    this.service.updateAgentDetails(payload).subscribe((res: any) => {
      if (res?.success) {
        this.message = res?.message || 'Changes saved successfully!';
        this.openModal('saveModal');
      } else {
        this.showErrorMessage(res);
      }
    });
  }

  public showErrorMessage(res) {
    if (res?.data?.Validations?.length) {
      let validations = res.data.Validations[0]
        .split(',')
        .map((v) => v.trim())
        .filter((v) => v.length > 0);

      this.arrvalidationerrors = validations;
    }
    if (this.arrvalidationerrors.length > 0) {
      this.openModal('errorModal');
    }
  }

  closeErrorModal() {
    this.closeModal('errorModal');
  }

  closeSaveModal() {
    this.closeModal('saveModal');
    this.showProfile = true;
    this.message = '';
  }

  private transformSectionData(formData: any) {
    const transformed: any = {};

    Object.keys(formData).forEach((sectionName) => {
      const normalizedKey = sectionName;
      const sectionFields = formData[sectionName];
      const sectionData: any = {};

      Object.keys(sectionFields || {}).forEach((fieldKey) => {
        let value = sectionFields[fieldKey] ?? '';
        sectionData[fieldKey] = value;
      });
      transformed[normalizedKey] = sectionData;
    });
    return transformed;
  }
}
